import React from 'react';
import { EarningsReportComponentV2 } from './earnings-report-component-v2';
import { TranscriptComponent } from './transcript-component';
import { useAppDispatch } from '../store/hooks';
import { setEnlargedReport } from '../store/layout-reducer';

interface DataViewProps {
    supportedTickers: string[];
    // Earnings props
    earningsReport: {
        currentTicker: string;
        setCurrentTicker: (ticker: string) => void;
        reports: any[];
        fiscalPeriod: string | null;
        fiscalYear: string | null;
        setFiscalYear: (year: string) => void;
        setFiscalPeriod: (period: string) => void;
        dates: any[];
        loadNextReport: () => void;
    };
    // Transcript props
    transcript: {
        currentTicker: string;
        setCurrentTicker: (ticker: string) => void;
        transcript: any;
        fiscalDateEnding: string | null;
        setCurrentFiscalDateEnding: (date: string) => void;
        dates: any[];
    };
    conversationId: string | undefined;
    isEarningsTableView: boolean;
    handleSetIsEarningsTableView: (value: boolean) => void;
}

export const DataView: React.FC<DataViewProps> = ({
    supportedTickers,
    earningsReport,
    transcript,
    conversationId,
    isEarningsTableView,
    handleSetIsEarningsTableView
}) => {
    const dispatch = useAppDispatch();

    return (
        <div className="research-grid h-full w-full grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Earnings Column */}
            <div className="research-panel min-w-0 overflow-hidden">
                <div className="h-full overflow-y-auto">
                    <EarningsReportComponentV2
                        supportedTickers={supportedTickers}
                        setCurrentTicker={earningsReport.setCurrentTicker}
                        currentTicker={earningsReport.currentTicker}
                        earningsReports={earningsReport.reports}
                        fiscalPeriod={earningsReport.fiscalPeriod || ''}
                        fiscalYear={earningsReport.fiscalYear || ''}
                        setFiscalYear={earningsReport.setFiscalYear}
                        setFiscalPeriod={earningsReport.setFiscalPeriod}
                        earningsDates={earningsReport.dates}
                        onViewChange={handleSetIsEarningsTableView}
                        setTableView={(v: boolean) => {
                            if (conversationId) {
                                dispatch(setEnlargedReport({
                                    conversationId: conversationId,
                                    enlarged: v
                                }));
                            }
                        }}
                        tableView={isEarningsTableView}
                        loadNextReport={earningsReport.loadNextReport}
                    />
                </div>
            </div>

            {/* Transcript Column */}
            <div className="research-panel min-w-0 overflow-hidden">
                <div className="h-full overflow-y-auto">
                    <TranscriptComponent
                        setCurrentTicker={transcript.setCurrentTicker}
                        supportedTickers={supportedTickers}
                        ticker={transcript.currentTicker}
                        transcript={transcript.transcript}
                        currentFiscalDateEnding={transcript.fiscalDateEnding || ''}
                        setCurrentFiscalDateEnding={transcript.setCurrentFiscalDateEnding}
                        earningsDates={transcript.dates}
                    />
                </div>
            </div>
        </div>
    );
};
